import React from 'react';
import { inject, observer } from 'mobx-react';
import './ProductSelector.scss';

@inject('ProductStore', 'Navigator')
@observer
class ProductSelector extends React.Component {
    handleSelectProduct = (productId) => {
        this.props.ProductStore.setProduct(productId);
        this.props.Navigator.push('/');
    };

    render() {
        const { ProductStore } = this.props;

        return (
            <div className="product-selector-container">
                <div className="product-selector-content">
                    <h1>Selecione o produto desejado</h1>
                    <p className="product-selector-lead">
                        Para acessar a plataforma, por favor escolha um dos seguintes produtos abaixo.
                    </p>
                    <p className="product-selector-lead">
                        Uma vez selecionado, você poderá alterar o produto ativo pelo menu.
                    </p>

                    <div className="product-options">
                        {ProductStore.products.map((product) => (
                            <div
                                key={product.id}
                                className="product-card"
                                role="button"
                                tabIndex={0}
                                onClick={() => this.handleSelectProduct(product.id)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        this.handleSelectProduct(product.id);
                                    }
                                }}
                            >
                                <span className="product-card-name">{product.name}</span>
                                <button
                                    type="button"
                                    className="product-card-action"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.handleSelectProduct(product.id);
                                    }}
                                >
                                    Acessar
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductSelector;



// WEBPACK FOOTER //
// ./src/containers/ProductSelector.js